import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

import { publicEnv } from "@/env/public-env";
import { User } from "@/lib/types/auth";
import { useAuth } from "@/stores/use-auth";

function buildSentryUser(user: User) {
  return {
    id: user.id,
    email: user.email,
    name: user.name,
  };
}

export default function useSentryTracker() {
  const { isLoading, user } = useAuth();

  useEffect(() => {
    if (!isLoading && !!publicEnv.NEXT_PUBLIC_SENTRY_NEXT_FE_DSN) {
      if (user) {
        const builtUser = buildSentryUser(user);

        Sentry.setUser(builtUser);
      } else {
        Sentry.setUser(null);
      }
    }
  }, [isLoading, user]);

  return null;
}
